import { render, staticRenderFns } from "./my-btn.vue?vue&type=template&id=c84fa30e&scoped=true&"
import script from "./my-btn.vue?vue&type=script&lang=js&"
export * from "./my-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84fa30e",
  null
  
)

export default component.exports